import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

export class CalendarTabsProvider {

    static inject = () => [MixPanelEventEmitter];
    constructor(private tracking: MixPanelEventEmitter) {}

    getTabs = () => {
        return {
            tabGroupId: 'calendar-tabs',
            tabs: [
                {
                    label: 'Appointments',
                    url: `/calendar/appointments`,
                    dataId: 'appointments-tab'
                },
                {
                    label: 'Journal',
                    url: `/calendar/journal`,
                    dataId: 'journal-tab',
                    onClick: () => {
                        this.tracking.track(
                            'Daily Log Calendar Opened',
                            () => ({'Opened From': 'Calendar Page'})
                        );
                    }
                }
            ]
        };
    };
}
